import React from 'react';
import './Pricing.css';

const Pricing = () => {
    return (
        <div className="pricing-container">
            {/* Welcome Message Below the Banner */}
            <section className="pricing-welcome">
                <h1>Simple & Transparent Pricing</h1>
                <p>No one likes convoluted fee structures. With Salva we made it simple. Get full-service tax support, no matter your situation.
                    <br></br>
                    <br></br>
                    For the majority of our clients that means one flat fee and you're home free.</p>
            </section>

            {/* Pricing Tiers */}
            <div className="pricing-tiers">
                {/* Tier 1: Freedom */}
                <div className="pricing-card">
                    <h2>Freedom</h2>
                    <p className="price">$100</p>
                    <ul>
                        <li> Wages, Interest & Dividends</li>
                        <li> Standard Deduction</li>
                    </ul>
                </div>

                {/* Tier 2: Essential */}
                <div className="pricing-card">
                    <h2>Essential</h2>
                    <p className="price">$150 </p>
                    <ul>
                        <li> Everything in Freedom</li>
                        <li> Unlimited State Filings</li>
                        <li> Student Loan Deductions</li>
                        <li> Education Credits</li>
                        <li> Nonresident Aliens (Basic)</li>
                    </ul>
                </div>

                
                {/* Tier 3: Advanced - Recommended */}
                <div className="recommended-container">
                    <div className="recommended-tab">Most Common</div>
                    <div className="pricing-card recommended">
                        <h2>Advanced</h2>
                        <p className="price">$200</p>
                        <ul>
                            <li>Everything in Essential</li>
                            <li>Sale of Stocks and Bonds</li>
                            <li>Sale of Cryptocurrency<sup>1</sup></li>
                            <li>Gambling Winnings</li>
                            <li>Health Savings Accounts</li>
                        </ul>
                        <br></br>
                        <p><sup>1</sup>Crypto basis required</p>
                    </div>
                </div>

                {/* Tier 4: Elite */}
                <div className="pricing-card">
                    <h2>Elite</h2>
                    <p className="price">$275 </p>
                    <ul>
                        <li> Everything in Advanced</li>
                        <li> Itemized Deductions</li>
                        <li> Dependents and Childcare</li>
                        <li> Sale of Cryptocurrency </li>
                    </ul>
                </div>
            </div>

            {/* Self-Employed Section */}
            <section className="self-employed-section">
                <h2>Self-Employed?</h2>
                <p>We offer specialized tax services for freelancers, property managers, contractors, and business owners.</p>

                {/* Center-Aligned Self-Employed Pricing Card */}
                <div className="self-employed-container">
                    <div className="pricing-card self-employed">
                        <h2>Self-Employed</h2>
                        <p className="price">$350 + Hourly Rate</p>
                        <ul>
                            <li> First Hour Free</li>
                            <li> Schedule C and Schedule E</li>
                            <li> Bookkeeping and Accounting</li>
                            <li> Expense & Deduction Optimization</li>
                            <li> Estimated Payments Support</li>
                        </ul>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Pricing;
